import React, { useState } from "react"
import { navigate } from "gatsby"

import Seo from "@components/seo"
import Header from "@components/header/header"
import { languageUtils } from "@utils/language"
import menuOptions from "@data/menu-options.json"

const Layout = ({ children }) => {
  const [language, setLanguage] = useState(languageUtils.getLanguage())
  const [options, setOptions] = useState(
    menuOptions[languageUtils.getLanguage()]
  )
  const changeLanguage = () => {

  const newLanguage = languageUtils.toggleLanguage()
    setLanguage(newLanguage)

    setOptions(menuOptions[newLanguage])

    const path = getPath()
    let index = menuOptions[newLanguage === "es" ? "en" : "es"]
      .map(option => option.url)
      .indexOf(path)

    if (index >= 0) {
      navigate(menuOptions[newLanguage][index].url)
    } else {
      navigate("/" + newLanguage)
    }

  }

  const getPath = () => {
    const lang = languageUtils.getLanguage()
    let path =
      typeof window !== "undefined" ? window.location.pathname : "/" + lang
    let parts = path.split("/")

    while (parts[0] !== lang) {
      parts.shift()
    }

    path = `/${parts[0]}/${parts[1]}/`

    return path
  }

  return (
    <>
      <Seo
        lang={language}
        title={language === "es" ? "Memoria Anual 2020" : "Annual Report 2020"}
      />

      <Header
        language={language}
        onChange={changeLanguage}
        menuOptions={options}
      />

      <div className={`page-content ${language}`}>{children}</div>
    </>
  )
}

export default Layout
